import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import serviceData from "../../Data/serviceData";
import { Link } from "react-router-dom";

const ServiceSection = () => {
  // State for managing the active tab (either "Pest Control" or "Cleaning")
  const [activeTab, setActiveTab] = useState("Cleaning");
  const [services, setServices] = useState([]);

  useEffect(() => {
    setServices(serviceData);
  }, []);

  // Filter services based on the selected category (tab)
  const filteredServices = services.filter(
    (service) => service.category === activeTab,
  );

  // Slider settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at once
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Handle tab change
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section
      className="service-area12 overflow-hidden space"
      id="service-sec"
      style={{
        backgroundImage: "url(assets/img/update2/bg/service_bg_1.jpg)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="title-area mb-0 text-center">
            <span className="sub-title6 justify-content-center">
              <span className="shape left">
                <span className="dots"></span>
              </span>
              OUR SERVICES
              <span className="shape right">
                <span className="dots"></span>
              </span>
            </span>
            <h2 className="sec-title">The Best Services We Offer</h2>
          </div>
        </div>

        <div className="nav nav-tabs service-tabs" id="nav-tab" role="tablist">
          <button
            className={`nav-link th-btn ${
              activeTab === "Cleaning" ? "active" : ""
            }`}
            onClick={() => handleTabClick("Cleaning")}
            type="button"
          >
            Cleaning Service
          </button>
          <button
            className={`nav-link th-btn ${
              activeTab === "Pest Control" ? "active" : ""
            }`}
            onClick={() => handleTabClick("Pest Control")}
            type="button"
          >
            Pest Control Service
          </button>
        </div>

        <div className="tab-content" id="nav-tabContent">
          <div className="tab-pane fade active show" role="tabpanel">
            <Slider {...settings}>
              {filteredServices.map((service, index) => (
                <div className="col-md-6 col-lg-4 hh" key={index}>
                  <div
                    className="service-box"
                    style={{
                      backgroundImage: `url(assets/img/update2/bg/shape_bg_1.png)`,
                    }}
                  >
                    <div className="service-content">
                      <div className="service-box_icon">
                        <img
                          src={service.icon}
                          alt="icon"
                          style={{
                            height: "60px",
                            width: "60px",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <div className="service-box_number">{service.number}</div>
                    </div>
                    <h3 className="box-title">
                      <Link to="">{service.title}</Link>
                    </h3>
                    <p className="service-box_text">{service.subTitle}</p>
                    <Link
                      className="line-btn"
                      to={`/service/service-details/${service.id}`}
                    >
                      Read More <i className="fas fa-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
